export const SUPER_ADMIN_ROLE = 'super_admin';
export const SERVICETITAN_SUPPORT_ROLE = 'service_titan_support';
export const SCOPE_NAME = 'eh_client';
export const FF_CLIENT_SIDE_ID_SETTING_KEY = 'ldClientSideId';
